import type { IdentityInfoTrackData } from "common-types";
import { send } from "./sender";
import type { IdentityInfoSenderBody } from "../types";
import {
  getBeaconId,
  getSessionId,
  getTrackingPvUid,
} from "../utils/beaconParams";
import { getWikiSkinOverride } from "./trackingEventSender";

export async function sendIdentityInfo({
  payload,
}: Pick<IdentityInfoTrackData, "payload">) {
  const body: IdentityInfoSenderBody = {
    partner_name: payload.partnerName,
    partner_identity_id: payload.partnerIdentityId,
    pv_unique_id: getTrackingPvUid(),
    session_id: getSessionId(),
    beacon: getBeaconId(),
    ua: window.navigator.userAgent,
    s: getWikiSkinOverride(),
  };

  send("identityinfo", body);
}
